"use client";

import { useEffect } from "react";
import { useParams } from "next/navigation";
import { getFunnelPlannerContent } from "@/lib/content/entries/funnel-planner";
import { ALL_APP_LOCALES, DEFAULT_LOCALE, type AppLocale } from "@/lib/i18n/constants";
import { funnelText } from "@/lib/funnel-planner/i18n";

export default function FunnelPlannerError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const params = useParams<{ locale?: string }>();
  const locale = ALL_APP_LOCALES.includes(params?.locale as AppLocale)
    ? (params.locale as AppLocale)
    : DEFAULT_LOCALE;
  const content = getFunnelPlannerContent(locale);

  useEffect(() => {
    console.error("FunnelPlannerPage error:", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-sm text-muted-foreground">
        {funnelText(content, "routeErrorMessage", "Something went wrong loading the funnel planner.")}
      </p>
      <button
        onClick={reset}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        {funnelText(content, "tryAgainButton", "Try again")}
      </button>
    </div>
  );
}
